import { render, staticRenderFns } from "./StreamerClips.vue?vue&type=template&id=44c76a6d&"
import script from "./StreamerClips.vue?vue&type=script&lang=js&"
export * from "./StreamerClips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports